import React from "react";
import { useQuery } from "@tanstack/react-query";
import parse from "html-react-parser";

import { useThemeChange } from "../../../utils/themeChange";
import { useApi } from "../../../hooks/api/useApi";
import { CMS } from "../../../constants/api-constants";

const { TEMPLATES } = CMS;

const Index = () => {
  const themeChange = useThemeChange();
  const { getById } = useApi();

  const aboutContent = useQuery({
    queryKey: ["about"],
    queryFn: () => getById("ABOUT", TEMPLATES),
  });

  if (aboutContent.isSuccess && aboutContent?.data) {
    const about_content = JSON.parse(aboutContent?.data?.data);
    var content = parse(about_content?.about_us);
  }
  return (
    <div className={themeChange.add("section")}>
      <section className="container static-page-container">
        <span className="spacer-30" />
        {content ? (
          content
        ) : (
          <div className="error">
            <p>Data Unavailable. Please contact admin.</p>
          </div>
        )}
        {/* <span className="spacer-30" />
        <h2>About Us</h2>
        <span className="spacer-30" />
        <p>
          Based in Glen Rock, New Jersey, the ArtSwap, LLC team is focused on
          bridging technology and law to meet the needs of artists.
        </p>
        <p>
          By using the tools developed by ArtSwap, artists can more easily
          license their fine art to manufacturers and brands. Please reach out
          to us at info @ artswap.com or 201-281-5134 to schedule a demo of the
          platform and learn how we can help you further monetize your art.
        </p> */}
      </section>
    </div>
  );
};

export default Index;
